export const SUPPORTED_LOCALES = ["en-GB", "es", "pt-PT"] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "en-GB";

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return (
    typeof value === "string" &&
    (SUPPORTED_LOCALES as readonly string[]).includes(value)
  );
}

/** The deployment value that follows each visitor's browser instead of
 *  pinning a locale: best effort, English (UK) when nothing matches. */
export const BROWSER_LANGUAGE = "browser";

const primarySubtag = (tag: string) => tag.split("-")[0].toLowerCase();

export function resolveLocale(
  value: unknown,
  browserLanguages: readonly string[] = []
): SupportedLocale {
  if (value === BROWSER_LANGUAGE) {
    for (const tag of browserLanguages) {
      const match = SUPPORTED_LOCALES.find(
        (locale) => primarySubtag(locale) === primarySubtag(tag)
      );
      if (match) return match;
    }
    return DEFAULT_LOCALE;
  }
  return isSupportedLocale(value) ? value : DEFAULT_LOCALE;
}

// The BCP-47 tag the browser's speech recognition takes for each widget locale.
export const DICTATION_LANGUAGE: Record<SupportedLocale, string> = {
  "en-GB": "en-GB",
  es: "es-ES",
  "pt-PT": "pt-PT",
};
